<template>
  <div>
    <div class="master-detail-caption"></div>
    <DxDataGrid
      :data-source="verficationDetails"
      :show-borders="true"
      :column-auto-width="true"
    >
      <DxPaging :page-size="20" />

      <DxColumn
        data-field="StructureDescription"
        caption="Δομή"
        :allow-editing="false"
        alignment="left"
      />
      <DxColumn
        data-field="AttendanceDate"
        caption="Παρουσία την"
        data-type="date"
        format="EEEE, d MMMM, yyyy"
        width="200px"
        alignment="left"
      />
      <DxColumn
        data-field="ParentFullName"
        caption="Ωφελούμενη/ος"
        :allow-editing="false"
        alignment="left"
      />
    </DxDataGrid>
  </div>
</template>
<script>
import mainService from "../../services/mainService";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
  },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      verficationDetails: [],
    };
  },
  async mounted() {
    await this.getVerificationDetails();
  },
  methods: {
    async getVerificationDetails() {
      var verificationId = this.templateData.data.Id;
      var res = await mainService.get(
        `/Verifications/GetVerificationDetails?verificationId=${verificationId}`
      );
      this.verficationDetails = res.data;
    },
  },
};
</script>

<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.dx-header-row {
  font-weight: bold;
}
</style>
